if (!customElements.get('cart-remove-button')) {
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.closest('cart-drawer').updateQuantity(this.dataset.index, 0);
      });
    }
  }

  customElements.define('cart-remove-button', CartRemoveButton);
}

if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: 'main-cart-items',
          selector: '.js-contents'
        },
        {
          id: 'main-cart-footer',
          section: 'main-cart-footer',
          selector: '.js-contents'
        }
      ];
    }

    connectedCallback() {
      this.body = document.querySelector('body');
      this.cartCount = document.querySelector('.cart-count-bubble');
      this.drawer = document.getElementById('shopify-section-cart-drawer');
      this.overlay = document.getElementById('cart-overlay');
      this.revealBtn = document.getElementById('cart-reveal');

      this.fetchAndOpenCart = this.fetchAndOpenCart.bind(this);
      this.closeDrawer = this.closeDrawer.bind(this);

      this.revealBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.fetchAndOpenCart();
      })

      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.closeDrawer.bind(this))
      );

      this.overlay.addEventListener('click', (e) => {
        this.closeDrawer();
      })

    }

    fetchCart(callback) {
      const sections = this.getSectionsToRender().map((section) => section.section);

      fetch(`${window.location.pathname}?sections=${sections.join(',')}`)
        .then(response => response.json())
        .then(parsedState => {
          this.renderCart({ sections: parsedState });
          if ((typeof callback) === 'function') {
            callback();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    updateQuantity(line, quantity, name) {

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));
          this.updateCartCount();
          // HACK: focus back on button/input after refresh of section
          // const lineItem = document.getElementById(`cart-product-${line}`);
          // if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        })
        .catch((err) => {
          console.log(err);
          console.error(window.cartStrings.error);
        })
    }

    renderCart(parsedState) {
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
      this.updateCartCount();
    }

    updateCartCount() {
      this.cartItemCount = document.querySelector('[data-cart-length]') ? document.querySelector('[data-cart-length]').dataset.cartLength : null;
      this.cartCount.innerHTML = this.cartItemCount ? parseInt(this.cartItemCount, 10) : null;
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    openDrawer() {
      this.body.classList.add('drawer-active');
      this.drawer.classList.add('is-active');
    }
    closeDrawer() {
      this.body.classList.remove('drawer-active');
      this.drawer.classList.remove('is-active');
    }

    fetchAndOpenCart() {
      this.fetchCart(() => {
        this.openDrawer();
      });
    }
  }

  customElements.define('cart-drawer', CartDrawer);

}
